import 'backbone-model-composite';

import Backbone from "backbone";
import md5 from "md5";

export default Backbone.ModelComposite.extend( {

   urlRoot: function () {
      return "/news-api/lists/" + this.listId + "/members"
   },

   // https://github.com/samolsen/backbone-model-composite
   childModels: {
      interests: Backbone.Model,
   },

   defaults: {
      "email_address": "",
      "status": "subscribed",
   },

   subscriberExists: false,

   initialize: function ( attributes, options ) {
      this.listId = options && options.listId;

      this.listenTo( this, 'change:email_address', ( model, value ) => {
         this.set( 'id', md5( value.trim().toLowerCase() ) )
      } );
      this.listenTo( this, 'sync', ( model ) => {
            model.subscriberExists = true // Need to know for unsubscribe
         }
      );
   },

   // https://stackoverflow.com/questions/46155/how-to-validate-email-address-in-javascript
   validEmailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

   validate: function ( attributes ) {
      if( !this.validEmailRegex.test( attributes.email_address ) ) {
         return true;
      }
   },

   set: function ( key, val, options ) {
      Backbone.Model.prototype.set.apply( this, arguments );
      // Handle both `"key", value` and `{key: value}` -style arguments.
      let attrs;
      if( typeof key === 'object' ) {
         attrs = key;
         options = val;
      }
      else {
         (attrs = {})[key] = val;
      }

      if( !options || !options.excludeChildModels ) {
         _.each( _.keys( _.result( this, 'childModels' ) ), function ( key ) {
            attrs[key] && this[key].set( attrs[key], options )
         }, this );
      }
      return this
   },

   // **parse** converts a response into the hash of attributes to be `set` on  the model.
   parse: function ( resp, options ) {
      if( resp.status && resp.status !== 'subscribed' ) {
         resp.interests = _.mapObject( resp.interests, () => {
            return false
         } );
      }
      return resp;
   },

} );


// WEBPACK FOOTER //
// ./news/components/MemberModel.js